import ShakhsSalesBimehNamehPrintSliceType from '../../../../../ShakhsSales/SakhsSalesBimehNameh/Pages/Print/reducers/ShakhsSalesBimehNamehPrintSliceType';

const ShakhSalesBimehNamehPrintInitialState: ShakhsSalesBimehNamehPrintSliceType = {
  print: {
    loading: false,
  },
  PrintDisplay: {
    loading: false,
    data: null,
  },
  ShomarehBimehNamehHa: {
    loading: false,
    data: null,
  },
};

export default ShakhSalesBimehNamehPrintInitialState;
